import { createSlice, createSelector, createAsyncThunk } from '@reduxjs/toolkit';
import { getInfosCorrespondant } from "../../api/correspondantsService";

const initialState = {
    keycloakReduce: {},
    infosCorrespondant: {},
    loadingInfosCorrespondant: false,
}

export const fetchInfosCorrespondant = createAsyncThunk("fetchInfosCorrespondant",
    async(idGrm) => {

        return await getInfosCorrespondant(idGrm)
    })

const keycloakSlice = createSlice({
    name: "keycloak",
    initialState,
    reducers: {
        initKeycloak(state, action) {
            return {
                ...state,
                ...initialState,
            }
        },
        updateKeycloak(state, action) {
            return {
                ...state,
                keycloakReduce: {
                    ...state?.keycloakReduce,
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    ...action?.payload,
                }
            }
        },
        // updateInfosCorrespondant(state, action) {
        //     if (action?.payload !== undefined) {
        //         state.infosCorrespondant = action?.payload
        //     }
        // },
    },
    extraReducers: builder => {
        builder
            .addCase(fetchInfosCorrespondant.pending, (state, action) => {
                state.loadingInfosCorrespondant = true
            })
            .addCase(fetchInfosCorrespondant.fulfilled, (state, action) => {

                state.infosCorrespondant = action.payload
                state.loadingInfosCorrespondant = false
            })
            .addCase(fetchInfosCorrespondant.rejected, (state, action) => {
                state.loadingInfosCorrespondant = false
                state.error = action?.error?.message
            })
    }
})

export const {
    initKeycloak,
    updateKeycloak,
    // updateInfosCorrespondant,
} = keycloakSlice.actions

export default keycloakSlice.reducer